import React from 'react';
import { Building2, Users2 } from 'lucide-react';
import { UnavailableDataBadge } from '../UnavailableDataBadge';
import { Timeline } from '../Timeline';

interface TaskInfoProps {
  name: string;
  operation: string | null;
  team: string | null;
  dates: {
    opening: string | null;
    start: string | null;
    completion: string | null;
  };
  isEnglish: boolean;
}

export const TaskInfo: React.FC<TaskInfoProps> = ({
  name,
  operation,
  team,
  dates,
  isEnglish,
}) => (
  <div className="border-b pb-6 mb-6 print:pb-4 print:mb-4">
    <h1 className="text-3xl font-bold text-gray-800 mb-4 print:text-2xl">{name}</h1>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div className="flex items-center gap-2 text-gray-600">
        <Building2 className="w-4 h-4 print:w-3 print:h-3" />
        <span className="print:text-sm">
          {isEnglish ? 'Operation' : 'Operação'}: {operation || <UnavailableDataBadge />}
        </span>
      </div>
      <div className="flex items-center gap-2 text-gray-600">
        <Users2 className="w-4 h-4 print:w-3 print:h-3" />
        <span className="print:text-sm">
          {isEnglish ? 'Team' : 'Time'}: {team || <UnavailableDataBadge />}
        </span>
      </div>
    </div>

    <Timeline dates={dates} isEnglish={isEnglish} />
  </div>
);